import { UserRoleName } from 'domain/UserProfile';
import { InferType, mixed, number, object, string } from 'yup';

export const eventHostSchema = object({
  accountId: number().required(),
  name: string(),
  email: string().required(),
  avatarLink: string().nullable(),
  role: string().nullable(),
  // Null for a host with no role in the event's community: hosting does not require membership.
  communityRole: mixed<UserRoleName>().nullable(),
});

export type EventHostType = InferType<typeof eventHostSchema>;
